import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LeadsSignupServiceService, SignupLeadPayload, SignupLeadResponse,Country } from './services/leads-signup-service.service';
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { CanonicalService } from '../../shared/seo/canonical.service';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-leads-signup',
  imports: [CommonModule,ReactiveFormsModule],
  templateUrl: './leads-signup.component.html',
  styleUrl: './leads-signup.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LeadsSignupComponent {

  signupForm: FormGroup;
  isSubmitting = false;
  countries: Country[] = [];


  utmSource: string | null = null;
  utmMedium: string | null = null;
  utmCampaign: string | null = null;
  utmContent: string | null = null;
  
  constructor(
    private fb: FormBuilder,
    private leadsSignupService: LeadsSignupServiceService,
    private route: ActivatedRoute,
    private canonicalService: CanonicalService,
    private titleService: Title,
    private metaService: Meta,
  ) {

  this.signupForm = this.fb.group({
  name: [
    '',
    [
      Validators.required,
      Validators.pattern(/^[a-zA-Z]+(?: [a-zA-Z]+)*$/)
    ]
  ],

  email: [
    '',
    [
      Validators.required,
      Validators.pattern(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      )
    ]
  ],

  phone: [
    '',
    [
      Validators.required,
      Validators.pattern(/^[0-9]{10}$/)
    ]
  ],

  company: [
    '',
    [
      Validators.required,
       Validators.pattern(/^[a-zA-Z]+(?: [a-zA-Z]+)* ?$/)
    ]
  ],

  country: [
    '',
    Validators.required
  ],

  service: [
    '',
    Validators.required
  ]
});
  }
ngOnInit(): void {


   this.titleService.setTitle(
    'Sign Up for MALtech Email API, Bulk Email & Automation'
  );

this.metaService.updateTag({
  name: 'description',
  content:
    'Sign up for MALtech email services and get started with Transactional Email API, Bulk Email API, Email Integration, and Email Automation for reliable business communication.'
});

this.metaService.updateTag({
  name: 'keywords',
  content:
    'MALtech email services, MALtech signup, Transactional Email API, Bulk Email API, Email Integration, Email Automation, email API, business email services'
});

  this.metaService.updateTag({
    name: 'robots',
    content: 'index, follow'
  });

  this.canonicalService.setCanonicalURL(
    'sign-up/'
  );

  // Read UTM parameters
  this.route.queryParams.subscribe(params => {

    this.utmSource = params['utm_source'] ?? null;
    this.utmMedium = params['utm_medium'] ?? null;
    this.utmCampaign = params['utm_campaign'] ?? null;
    this.utmContent = params['utm_content'] ?? null;

    console.log('UTM Parameters:', {
      utm_source: this.utmSource,
      utm_medium: this.utmMedium,
      utm_campaign: this.utmCampaign,
      utm_content: this.utmContent
    });

  });

  // Load countries
  this.loadCountries();
}
loadCountries(): void {

  this.leadsSignupService.getCountries().subscribe({

    next: (countries: Country[]) => {

      this.countries = countries || [];

      console.log('Countries:', this.countries);

    },

    error: (error: any) => {

      console.error(
        'Failed to load countries:',
        error
      );

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to load countries.'
      });

    }

  });
}
  submitForm(): void {

    if (this.signupForm.invalid) {
      this.signupForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const payload: SignupLeadPayload = {
      name: this.signupForm.value.name.trim(),
      email: this.signupForm.value.email.trim(),
      phone: this.signupForm.value.phone.trim(),
      company_name: this.signupForm.value.company.trim(),
      country: this.signupForm.value.country,
      service_type: this.signupForm.value.service,

      utm_source: this.utmSource,
      utm_medium: this.utmMedium,
      utm_campaign: this.utmCampaign,
      utm_content: this.utmContent
    };

    console.log('Signup Lead Payload:', payload);

this.leadsSignupService
  .createSignupLead(payload)
  .subscribe({

    next: (response: SignupLeadResponse) => {

      console.log('Signup successful:', response);

      this.isSubmitting = false;

      this.signupForm.reset();

      Swal.fire({
        icon: 'success',
        title: 'Signup Successful!',
        text: 'Thank you for signing up. Our team will contact you shortly.',
        confirmButtonText: 'OK',
        confirmButtonColor: '#009fe4'
      });

    },

    error: (error: any) => {

      console.error('Signup failed:', error);

      this.isSubmitting = false;

      if (error.status === 409) {

        Swal.fire({
          icon: 'warning',
          title: 'Already Registered',
          text: 'A lead with this email already exists.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#009fe4'
        });

      } else {

        Swal.fire({
          icon: 'error',
          title: 'Submission Failed',
          text: 'Unable to submit your signup. Please try again.',
          confirmButtonText: 'OK',
          confirmButtonColor: '#009fe4'
        });

      }
    }

  });
  }



  onNameInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/[^a-zA-Z ]/g, '')
    .replace(/\s{2,}/g, ' ');

  this.signupForm.get('name')?.setValue(input.value, {
    emitEvent: false
  });
}


onEmailInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  // Remove spaces
  input.value = input.value.replace(/\s/g, '');

  this.signupForm.get('email')?.setValue(input.value, {
    emitEvent: false
  });
}


onPhoneInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/\D/g, '')
    .slice(0, 10);

  this.signupForm.get('phone')?.setValue(input.value, {
    emitEvent: false
  });
}


onCompanyInput(event: Event): void {
  const input = event.target as HTMLInputElement;

  input.value = input.value
    .replace(/[^a-zA-Z ]/g, '')
    .replace(/\s{2,}/g, ' ');

  this.signupForm.get('company')?.setValue(input.value, {
    emitEvent: false
  });
}
}